import { useCallback } from 'react';
import { useApiCall, useRootContext } from '@jarvis/react-portal-addons';
import { UserTenantMgtSvcClient } from '@jarvis/web-stratus-client';

const mapInternalUser = item => ({
  userResourceId: item.user?.resourceId,
  tenantResourceId: item.userTenantDetail?.tenantResourceId,
  rolePermId: item.userTenantDetail?.rolePermId,
  state: item.userTenantDetail?.state,
});

const mapExternalUser = item => ({
  userResourceId: item.resourceId,
  tenantResourceId: item.tenantResourceId,
  rolePermId: item.rolePermId,
  state: item.state,
});

const appendUsers = (response, mapUser, users, predicate) => {
  if (response?.status !== 200) {
    return;
  }

  response.data.resourceList
    .filter(predicate || (() => true))
    .map(mapUser)
    .forEach(item => users.push(item));
};

const useUserTenantApiCall = ({ init = true } = {}) => {
  const { shell: { authProvider, tenantHandler }, stack } = useRootContext();

  const apiCall = useCallback(async () => {
    const users = [];
    const userClient = new UserTenantMgtSvcClient(stack, authProvider);

    const tenantResourceId = tenantHandler.getTenantId();

    const userList = await userClient.getUserWithTenantList(tenantResourceId);
    appendUsers(
      userList,
      mapInternalUser,
      users,
      item => item.userTenantDetail?.tenantResourceId !== item.user?.idpId,
    );

    try {
      const extList = await userClient.getExternalUserList(tenantResourceId);
      appendUsers(extList, mapExternalUser, users);
    } catch (error) {
      // Handle 404 or other errors gracefully - continue with internal users only
      console.error('Failed to fetch external users:', error);
    }

    return users;
  }, [authProvider, tenantHandler, stack]);

  return useApiCall({
    initialData: [],
    apiCall,
    init,
  });
};

export default useUserTenantApiCall;
